import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App.jsx';
import { AuthProvider } from './contexts/AuthContext.jsx';
import { LanguageProvider } from './i18n/LanguageProvider.jsx';
import { useI18n } from './i18n/useI18n';
import { TelegramLoginCallback } from './pages/TelegramLoginCallback.jsx';
import { InvitePage } from './pages/InvitePage.jsx';
import ShareRedirect from './pages/ShareRedirect.jsx';
import { NotFoundPage } from './pages/NotFoundPage.jsx';

function LangKeyedRoutes() {
  const { lang } = useI18n();
  return (
    <Routes key={lang}>
      <Route path="/tglogin" element={<TelegramLoginCallback />} />
      <Route path="/invite/:code" element={<InvitePage />} />
      <Route path="/s/:shareId" element={<ShareRedirect />} />
      <Route path="/" element={<App />} />
      <Route path="/favorites/:slug" element={<App />} />
      <Route path="/market/:slug" element={<App />} />
      <Route path="/traders/:address" element={<App />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <LanguageProvider>
          <LangKeyedRoutes />
        </LanguageProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
